// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.b0EzcmqVYzSa5vl3gTTE{justify-content:flex-start;width:100%}.vGhnZLVh1AU7LAz7_oWN{background-color:var(--background-primary-inverted-primary);border:1px var(--border-neutral-default)solid;text-overflow:ellipsis;white-space:nowrap;border-radius:6px;max-width:100px;padding:4px 8px;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"createButton": `b0EzcmqVYzSa5vl3gTTE`,
	"createButtonLabel": `vGhnZLVh1AU7LAz7_oWN`
};
export default ___CSS_LOADER_EXPORT___;
